import { selectMenuCss } from '../../theme/selectStyles';
import styled, { css, createGlobalStyle } from 'styled-components';
import ThemedTooltip from '../../theme/ThemedTooltip';
import Select from 'react-select';
import { ReactComponent as InfoIcon } from '../../assets/img/tooltip-info-white.svg';
import { ReactComponent as LocationIcon } from '../../assets/img/server-location.svg';

export const serverSelectStyles = {
  menuPortal: base => ({ ...base, zIndex:40 }),
};
export const ServerSelectMenuGlobal = createGlobalStyle`
  ${selectMenuCss('server-select')}
`;

export const StyledServerSelect = styled(Select)`
  bottom: 0;
  background-color: transparent;
  width: 180px;
  margin-right: 15px;
  font-size: 13px;

  @media only screen and (max-width: 768px) {
    display: flex;
    width: 130px;
    margin-right: 0px;
    top: 0px;
    bottom: 100%;
    right: 0px;
  }

  .server-select__control {
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06));
    min-height: 25px;
    background-color: ${({ theme }) => theme.inset};
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.text};
    font-weight: 700;
    box-shadow: none;
    cursor: pointer;
    @media only screen and (max-width: 768px) {
      width: 100%;
      min-height: 38px;
      filter: none;
    }
  }

  .server-select__control:hover,
  .server-select__control--is-focused {
    border-color: ${({ theme }) => theme.border};
    box-shadow: none;
  }

  .server-select__placeholder {
    font-family: 'Archivo', sans-serif;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    color: ${({ theme }) => theme.textFaint};
    padding-left: 25px;
    @media only screen and (max-width: 768px) {
      font-size: 12px;
      padding-left: 20px;
    }
  }

  .server-select__single-value,
  .server-select__input-container {
    color: ${({ theme }) => theme.text};
  }

  .server-select__single-value {
    padding-left: 25px;
    @media only screen and (max-width: 768px) {
      font-weight: 400;
      font-size: 12px;
      padding-left: 20px;
    }
  }

  .server-select__indicator {
    color: ${({ theme }) => theme.textFaint};
    svg {
      fill: ${({ theme }) => theme.textFaint};
      width: 12px;
    }
  }

  .server-select__indicator-separator {
    display: none;
  }
`;
export const StyledLocationIcon = styled(LocationIcon)`
  width: 14px;
  height: 14px;
  position: absolute;
  left: 10px;
  z-index: 1;
  pointer-events: none;
  color: ${({ theme }) => theme.text};
  fill: currentColor;
  g {
    fill: currentColor;
  }
`;

export const StyledInfoIcon = styled(InfoIcon)`
  width: 12px;
  height: 12px;
  margin-left: 0px;
  ${({ iconsize }) => {
    if (iconsize)
      return css`
        width: ${iconsize}px;
        height: ${iconsize}px;
      `;
  }}
  &:focus,
  &:active {
    outline: none;
  }
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: solid 0.5px #e1e1e1;
  width: 190px;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;
export const StyledHeader = styled.div`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  h3 {
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: 0.18px;
    width: 450px;
    &:first-of-type {
      width: 250px;
      border-right: 1px solid ${({ theme }) => theme.border};
      border-top-left-radius: 4px;
    }
    &:last-of-type {
      border-top-right-radius: 4px;
    }
  }
`;
export const StyledBody = styled.div`
  flex-direction: row;
  width: 100%;
  display: flex;
`;
export const StyledSignUpContainer = styled.div`
  margin: 0 20px;
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 700px;
  overflow: hidden;
  @media only screen and (max-width: 991px) {
    background-color: transparent;
    border: 0;
    margin: 0;
  }

  h3 {
    color: ${({ theme }) => theme.headerText};
    background-color: ${({ theme }) => theme.nav};
    height: 42px;
  }
`;

export const StyledServersContainer = styled.div`
  min-width: 250px;
  box-shadow: 8px 0 14px -2px rgba(112, 112, 112, 0.08);
  height: 380px;
  /*   overflow-y: scroll; */
  @media only screen and (max-width: 991px) {
    width: 100%;
    height: 100%;
    padding: 0;
  }
`;
export const StyledServersList = styled.ul`
  height: 340px;
  overflow-y: scroll;
  padding: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  @media only screen and (max-width: 991px) {
    height: 100%;
    border: 0;
  }
`;
export const StyledServer = styled.li`
  position: relative;
  height: 30px;
  margin: 5px 0;
  display: ${(props) => (props.isFull ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-family: var(--tol-font-ui);
  font-weight: 400;
  border-radius: 6px;
  padding: 10px 10px 10px 20px;
  border: 0.1em solid transparent;
  cursor: pointer;
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 991px) {
    height: 48px;
    justify-content: start;
    font-size: 15px;
    font-weight: 600;
    margin: 15px 0;
  }
  &:before {
    position: absolute;
    display: ${({ noIcon }) => (noIcon ? 'none' : 'flex')};
    top: 10px;
    left: 10px;

    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${(props) => (props.isFull ? '#ea4335' : '#34a853')};
    @media only screen and (max-width: 991px) {
      display: none;
    }
  }
  &:hover {
    font-weight: 600;
    border: 0.1em solid ${({ theme }) => theme.border};
    background-color: ${({ theme }) => theme.hover};
  }
  ${({ isActive, theme }) => {
    if (isActive) {
      return css`
        font-weight: 600;
        border: 0.1em solid ${theme.border};
        background-color: ${theme.hover};
        @media only screen and (max-width: 768px) {
          background-color: ${theme.card};
          border: 0.1em solid transparent;
        }
      `;
    }
  }}
`;

export const StyledMobileSidebar = styled.div`
  background: ${({ customBg, theme }) => customBg || theme.page};
  height: 100%;
  width: 100%;
  position: fixed;
  margin-left: -100%;
  z-index: 11;
  top: 55px;
  left: 0px;
  padding-top: 0px;
  transition: all 0.5s ease 0s;
  overflow: auto;
  padding-bottom: 10px !important;
  ${({ isOpened }) => {
    if (isOpened) {
      return css`
        width: 100%;
        margin-left: 0;
      `;
    }
  }}
  h3 {
    margin-left: 15px;
    height: 46px;
    background-color: ${({ theme }) => theme.page};
    font-size: 15px;
    font-weight: bold;
    display: flex;
    align-items: center;
    flex-direction: row;
    color: ${({ theme }) => theme.text};
    @media only screen and (max-width: 768px) {
      margin-left: 0px;
      padding-left: 15px;
      border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
    }
    svg {
      margin-right: 20px;
    }
  }
  ${({ isOpened }) => {
    if (isOpened) {
      return css`
        width: 100%;
      `;
    }
  }}
`;
export const StyledUniverseLocation = styled.span`
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  max-width: 150px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  line-height: 1.27;
  color: ${({ theme, isActive }) =>
    isActive ? theme.textMuted : theme.textFaint};
  @media only screen and (max-width: 768px) {
    color: ${({ theme }) => theme.textMuted};
    margin-left: 3px;
    &:before {
      content: '- ';
    }
  }
`;

export const StyledSelectContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  bottom: 0;
  flex-direction: row;
  align-items: center;
  height: 40px;
  @media only screen and (max-width: 991px) {
    position: absolute;
    width: 130px;
    right: 9px;
    display: flex;
    flex-direction: row;
    top: -25px;
    height: 30px;
    bottom: 100%;
    right: 25px;
  }
`;
